import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import UsersTable from "components/Doobi/Users";
import UserAddressesTable from "components/Doobi/UserAddresses";
import UserWalletsTable from "components/Doobi/UserWallet";
import UserReferralsTable from "components/Doobi/UserReferral";

const UsersRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Users" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/referral/:id`} component={UserReferralsTable}/>
      <Route path={`${match.path}/wallet/:id`} component={UserWalletsTable}/>
      <Route path={`${match.path}/address/:id`} component={UserAddressesTable}/>
      <Route path={`${match.path}/`} component={UsersTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default UsersRoute;
